export interface INavigationRoute {
  name: string
  displayName: string
  meta?: { icon: string }
  children?: INavigationRoute[]
  /** Explicit counter names for badges; defaults to name + name_* */
  counters?: string[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'workflow',
      displayName: 'menu.workflow',
      meta: {
        icon: 'work',
      },
      counters: ['reviews_new', 'tutors_moderation'],
      children: [
        {
          name: 'workflow_reviews',
          displayName: 'menu.reviews',
          counters: ['reviews_new'],
        },
        {
          name: 'workflow_tutors',
          displayName: 'menu.tutors',
          counters: ['tutors_moderation'],
        },
      ],
    },
    {
      name: 'application_forms',
      displayName: 'menu.application_forms',
      meta: {
        icon: 'description',
      },
    },
    {
      name: 'articles',
      displayName: 'menu.articles',
      meta: {
        icon: 'article',
      },
    },
    {
      name: 'catalog',
      displayName: 'menu.catalog',
      meta: {
        icon: 'view_list',
      },
    },
    {
      name: 'directory',
      displayName: 'menu.directory',
      meta: {
        icon: 'folder',
      },
      children: [
        {
          name: 'tags_articles',
          displayName: 'menu.tags_articles',
        },
        {
          name: 'countries',
          displayName: 'menu.countries',
        },
        {
          name: 'programs',
          displayName: 'menu.programs',
        },
        {
          name: 'tutor_categories',
          displayName: 'menu.tutor_categories',
        },
      ],
    },
    {
      name: 'guides',
      displayName: 'menu.guides',
      meta: {
        icon: 'article',
      },
    },
    {
      name: 'institution_ads',
      displayName: 'menu.institution_ads',
      meta: {
        icon: 'campaign',
      },
    },
    {
      name: 'institutions',
      displayName: 'menu.institutions',
      meta: {
        icon: 'school',
      },
    },
    {
      name: 'invoice_offers',
      displayName: 'menu.invoice_offers',
      meta: {
        icon: 'receipt_long',
      },
    },
    {
      name: 'online_consultations',
      displayName: 'menu.online_consultations',
      children: [
        {
          name: 'calendar',
          displayName: 'menu.calendar',
        },
        {
          name: 'schedule_management',
          displayName: 'menu.schedule_management',
        },
      ],
      meta: {
        icon: 'view_list',
      },
    },
    {
      name: 'requests',
      displayName: 'menu.requests',
      meta: {
        icon: 'assignment_add',
      },
    },
    {
      name: 'requests_partnerships',
      displayName: 'menu.requests_partnerships',
      meta: {
        icon: 'assignment_add',
      },
    },
    {
      name: 'reviews',
      displayName: 'menu.reviews',
      meta: {
        icon: 'reviews',
      },
    },
    {
      name: 'tutor_requests',
      displayName: 'menu.tutor_requests',
      meta: {
        icon: 'school',
      },
    },
    {
      name: 'tutors',
      displayName: 'menu.tutors',
      meta: {
        icon: 'account_circle',
      },
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'groups',
      },
    }
  ] as INavigationRoute[],
}
